module.exports = __webpack_public_path__ + "img/buttons-layout-banner.283825ac.png";